import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageButtons } from 'library/components/controls/buttons/PageButtons';
import { home_HomeUrl } from 'main/routes/urls/RouteUrls';

import { ErrorContentProps } from './ErrorContent';

export const ErrorDetails = ({
	children,
	title,
	subtitle,
	description,
}: ErrorContentProps) => {
	const navigate = useNavigate();
	const { t } = useTranslation(['error', 'home']);
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				textAlign: 'center',
				pt: 3,
			}}>
			<div className="alert alert-danger" role="alert">
				<ReportProblemIcon fontSize="large" />
				<h2 className="alert-heading">{title}</h2>
				<p>{subtitle}</p>
				{!!description && (
					<>
						<hr />
						<p className="mb-0">{description}</p>
					</>
				)}
				{children}
				{
					<PageButtons
						primaryButtonLabel={t('home:root-title')}
						primaryButtonAction={() => {
							navigate(home_HomeUrl);
						}}
						withDivider={false}
					/>
				}
			</div>
		</Box>
	);
};
